import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<h1> Detail view </h1>",{ moduleName: "garaje/pods/components/message-log/show/template.hbs" })